const KeyValuePair = function(key, value) {
  this.key = key || null;
  this.value = value || null;
};
export default KeyValuePair;
